/**
 * In-memory composer drafts.
 *
 * Route changes unmount `ChatPage`, but the module instance stays alive. Keeping
 * drafts here restores text after navigating away and back without persisting
 * it across a full page refresh (which intentionally starts clean).
 */
const drafts = new Map<string, string>();

export function readDraft(conversationId: string | null | undefined): string {
  return conversationId ? drafts.get(conversationId) ?? '' : '';
}

export function writeDraft(conversationId: string | null | undefined, value: string): void {
  if (!conversationId) return;
  if (value === '') drafts.delete(conversationId);
  else drafts.set(conversationId, value);
}

export function clearDraft(conversationId: string | null | undefined): void {
  if (conversationId) drafts.delete(conversationId);
}

/** Test helper: a full page refresh would start with an empty module state. */
export function clearAllDrafts(): void {
  drafts.clear();
}
